<template>
  <admin-layout>
    <router-view></router-view>
  </admin-layout>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>